






































import Vue from 'vue';
// not going to refactor and type the VueSelect
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSelect from 'vue-select';
import { Cancelable } from 'underscore';
import config from '../../../../config';
import 'vue-select/dist/vue-select.css';
import FetchHelper from '../../../helpers/OldFetchHelper';
import { IAnotherCustomSelectOption } from '../../../common/interfaces/shared.interface';
import { IProduct } from '../../../common/interfaces/products.interface';
import { IMerchandiseItem } from '../../../common/interfaces/merchandise.interface';

interface IProductSelectComponent {
  options: unknown[];
  search: ((loading: (state: boolean) => void, searchString: string, vm: Record<string, unknown>) => void) & Cancelable | null;
  value: string;
}

interface IProductSelectRefs {
  vueSelect: typeof VueSelect & { clearSelection: () => unknown };
}

export default Vue.extend({
  components: {
    'v-select': VueSelect,
  },
  data(): IProductSelectComponent & { $refs?: IProductSelectRefs } {
    return {
      options: [],
      search: null,
      value: ``,
    };
  },
  props: {
    clearSearchOnSelect: {
      default: true,
      type: Boolean,
    },
    infoText: {
      required: true,
      type: String,
    },
    nothingFoundText: {
      required: true,
      type: String,
    },
    searchInMerchandise: {
      default: false,
      type: Boolean,
    },
  },
  mounted(): void {
    this.search = window._.debounce(this.searchFunction, 350);
  },
  methods: {
    clear(): void {
      this.$refs.vueSelect.clearSelection();
    },
    onSearch(search: string, loading: (state: boolean) => void) {
      if(!this.search) {
        return;
      }
      loading(true);
      this.search(loading, search, this as unknown as Record<string, unknown>);
    },
    async searchFunction(loading: (state: boolean) => void, searchString: string, vm: Record<string, unknown>): Promise<void> {
      if(!searchString || searchString.length < 3) {
        loading(false);
        return;
      }
      let response = await FetchHelper.get({
        path: `${config.api.paths.products.basepath}${config.api.paths.products.paths.search}/${searchString}`,
      });
      if(response.count < 1 && this.searchInMerchandise) {
        response = await FetchHelper.get({
          path: `${config.api.paths.products.basepath}${config.api.paths.products.paths.search}/${searchString}?merchandise=true`,
        });
      }
      if(response.success) {
        // eslint-disable-next-line no-param-reassign
        vm.options = response.data.map((r: IProduct | IMerchandiseItem): IAnotherCustomSelectOption => {
          return { code: r.matchcode, label: `${r.matchcode} - ${r.title}` };
        });
      }
      loading(false);
    },
  },
});
